// @flow
import { createSelector } from 'reselect';
import memoizeOne from 'memoize-one';
import { MOUNT_POINT } from './constants';
import type { SidePanel, State } from './reducer';

export const getSidePanelState: (state: Object) => State = (state) => state[MOUNT_POINT];

export const getSidePanelKey = (state: State, key: string): string => key;

export const getSidePanel: (state: State, key: string) => SidePanel = createSelector(
    [getSidePanelState, getSidePanelKey], (state, key) => state[key],
);

export const sensitivePanelIsOpened: (state: State) => SidePanel = createSelector(
    [getSidePanelState], (state) => Object.values(state).find((panel) => panel.sensitive),
);

export const hasOpenedPanels: (state: State) => SidePanel = createSelector(
    [getSidePanelState], (state) => Object.keys(state).length > 0,
);

export const makeGetSidePanel = memoizeOne((key) => (
    (state) => getSidePanel(state, key)
));
